import u from 'umbrellajs/umbrella.esm.js';

export function initPills() {
  u('.bsk-pills .bsk-pill-btn').on('click', function () {
    const name = this.dataset.tab;

    const $this = u(this);
    const $root = $this.closest('.bsk-pills-nav');
    if (!$root.length) return;

    $root.find('.bsk-pill-btn').attr('aria-selected', 'false');
    $this.attr('aria-selected', 'true');

    $root.find('.bsk-pill-contents > div').addClass('hidden');
    $root.find(`#${name}`).removeClass('hidden');
  });
}
